export const text = {
  product: "Product",
  feature: "Features",
  monthly: "Monthly",
  quarterly: "Quarterly",
  halfYearly: "Half-Yearly",
  annually: "Annually",
  start: "Get Started Now",
};
